import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { AnnouncementsApi } from '../../../../shared/services/api/announcements.api';
import { AnnouncementDetails } from '../../../../shared/models/announcement-details';

export const announcementDetailsResolver: ResolveFn<AnnouncementDetails> = (
  route,
) => {
  const api = inject(AnnouncementsApi);
  const idParam = route.paramMap.get('id');
  const parsedId = idParam ? Number(idParam) : NaN;

  if (!Number.isFinite(parsedId)) {
    throw new Error('Invalid announcement id.');
  }

  return api.getAnnouncementDetails$(parsedId);
};
